export default __webpack_public_path__ + "static/media/section-05-bg.faf61d72.svg";